import _ from 'lodash';
import { Form } from 'react-bootstrap';
import { Controller, FieldError, useFormContext } from 'react-hook-form';

import { Hint } from 'components/StyledTemplates/StyledTemplates';

import useScrollToError from 'hooks/useScrollToError';

const HookTextFormControl = (props: any) => {
    const {
        name,
        label,
        rules,
        onChange,
        defaultValue = '',
        type = 'text',
        trim = true,
        lowerCase = false,
        autoFocus = false,
        isPassword = false,
        ...rest
    } = props;
    const form = useFormContext();

    useScrollToError(name);

    return (
        <>
            {label && (
                <Form.Label>
                    {label}
                    {rules?.required && <span className="required-mark" />}
                </Form.Label>
            )}
            <Controller
                name={name}
                render={({ field }) => (
                    <Form.Control
                        {...field}
                        {...rest}
                        type={type}
                        autoFocus={autoFocus}
                        isInvalid={_.get(form.formState.errors, name)}
                        onBlur={(e: any) => {
                            if (e.target.value) {
                                let formatValue = String(e.target.value);
                                if (lowerCase) {
                                    formatValue = formatValue.toLowerCase();
                                }
                                if (trim) {
                                    formatValue = formatValue.trim();
                                }
                                if (e.target.value !== formatValue) {
                                    field.onChange(formatValue);
                                }
                            }
                            field.onBlur();
                        }}
                        onChange={(e: any) => {
                            if (e.target.value && lowerCase) {
                                e.target.value = String(e.target.value).toLowerCase();
                            }
                            field.onChange(e);
                            if (props.onChange) {
                                props.onChange(e);
                            }
                        }}
                        data-hj-allow={!isPassword}
                    />
                )}
                control={form.control}
                defaultValue={defaultValue}
                rules={rules}
            />
            {props.hint && <Hint>{props.hint}</Hint>}
            <Form.Control.Feedback type="invalid">
                {(_.get(form.formState.errors, name) as FieldError)?.message}
            </Form.Control.Feedback>
        </>
    );
};

export default HookTextFormControl;
